import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor() { }

  /**
 * Obtiene la versión completa del sistema operativo en formato semántico (X.Y.Z)
 * @returns Promise<string> - Versión completa del sistema operativo o string vacío si no se puede determinar
 */
  public getFullOSVersion = async (): Promise<string> => {
    const dataDevice = await Device.getInfo();
    const platformDevice = dataDevice.platform ?? 'unknown-platform';

    if (platformDevice === 'unknown-platform' as any) {
      return '';
    }

    // Para iOS, formatea el número a formato semántico (X.Y.Z)
    if (platformDevice === 'ios') {
      if (dataDevice.iOSVersion) {
        // Formatea el número como "18.5.0" desde algo como "180500"
        return String(dataDevice.iOSVersion)
          .replace(/(\d{2})(\d{2})(\d{2})/, '$1.$2.$3')
          .replace(/^0/, '')  // Elimina cero inicial si existe
          .replace(/\.0(\d)/g, '.$1')  // Convierte ".05" en ".5"
          .replace(/\.00/g, '.0');  // Convierte ".00" en ".0"
      }
      return '';
    }
    // Para Android, usar osVersion que ya viene en formato semántico
    else if (platformDevice === 'android') {
      return dataDevice.osVersion || '';
    }
    // Para web, usar webViewVersion
    else if (platformDevice === 'web' && dataDevice.webViewVersion) {
      return String(dataDevice.webViewVersion);
    }

    return '';
  }

  /**
   * Obtiene la versión principal (major) del sistema operativo
   * @returns Promise<number> - Número de versión principal o 0 si no se puede determinar
   */
  public getOSMajorVersion = async (): Promise<number> => {
    const fullVersion = await this.getFullOSVersion();

    if (!fullVersion) {
      return 0;
    }

    // Extraer el primer número antes del primer punto
    const majorVersion = parseInt(fullVersion.split('.')[0], 10);
    return isNaN(majorVersion) ? 0 : majorVersion;
  }
}
